import { useDossierContext } from './SuiviPrivatisationLayout';
import { PipelineDocuments } from './PipelineDocuments';

/** Onglet « Documents » — les justificatifs du parcours, rangés par nature. */
export function DossierDocumentsPage() {
    const { dossier } = useDossierContext();
    return <PipelineDocuments dossierId={dossier.dossier_id} documents={dossier.documents} />;
}
